import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const interruptChat = mutator({
  schema: z.object({
    entryId: z.string(),
    chatId: z.string(),
    branchId: z.string(),
  }),
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args: { entryId, chatId, branch } }) => {
    const [chat] = await tx.run(
      zql.chats
        .where("id", chatId)
        .related("commit", (c) => c.where("branchId", branch.id))
    );
    if (!chat?.commit) throw userFacingError("Chat not found on branch");

    const createdAt = Date.now();

    const lastEntries = await tx.run(
      zql.chatEntries
        .where("chatId", chatId)
        .orderBy("createdAt", "desc")
        .limit(1)
    );
    const previousEntryId = lastEntries[0]?.id ?? null;

    await tx.mutate.chatEntries.insert({
      id: entryId,
      chatId,
      entryType: "UserInterrupt",
      createdAt,
      previousEntryId,
      tenantId: ctx.tenantId,
    });

    await tx.mutate.workflowBranches.update({
      id: branch.id,
      lastChatEntryAt: createdAt,
      lastChatEntryType: "UserInterrupt",
      awaitingAction: false,
      respondingAt: null,
    });

    await tx.mutate.chats.update({
      id: chatId,
      lastChatEntryType: "UserInterrupt",
      awaitingAction: false,
      respondingAt: null,
    });

    await tx.mutate.workflows.update({
      id: branch.workflowId,
      updatedAt: createdAt,
    });
  },
});
